import { CountUp } from 'countup.js';

/**
 * Initializes CountUp animations for elements with `data-countup` attribute
 * when they scroll into view.
 * @param {HTMLElement} [container=document] - The container to search for counters.
 */
export function initializeCountUp(container = document) {
    const counters = container.querySelectorAll('[data-countup]');
    if (counters.length === 0) {
        return;
    }

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const counterElement = entry.target;

                const endVal = parseFloat(counterElement.dataset.end);
                if (isNaN(endVal)) {
                    console.warn('CountUp: Invalid or missing data-end value on element:', counterElement);
                    return;
                }

                // Get the delay from the data attribute, defaulting to 0 if not present.
                const delay = parseInt(counterElement.dataset.delay, 10) || 0;

                const options = {
                    prefix: counterElement.dataset.prefix || '',
                    suffix: counterElement.dataset.suffix || '',
                    separator: counterElement.dataset.separator === 'true' ? ',' : '',
                    decimalPlaces: (counterElement.dataset.end.split('.')[1] || '').length,
                    duration: 2.5,
                    useEasing: true,
                };

                const countUp = new CountUp(counterElement, endVal, options);
                if (!countUp.error) {
                    // Use setTimeout to delay the start of the animation.
                    setTimeout(() => {
                        countUp.start();
                    }, delay);
                } else {
                    console.error('CountUp error:', countUp.error);
                    counterElement.textContent = `${options.prefix}${endVal}${options.suffix}`;
                }
                observer.unobserve(counterElement);
            }
        });
    }, {
        threshold: 0.5
    });

    counters.forEach(counter => {
        observer.observe(counter);
    });
}